import React from "react";
import { Alert, SxProps, Theme } from "@mui/material";
import { getGroupPricingUpsell } from "../../constants/groupPricing";

/**
 * Upsell nudge shown when a department's cart quantity is within the
 * group-pricing lead window (e.g. 8/9 of 10). Renders nothing otherwise, so
 * once the group rate is unlocked the regular discount messaging takes over.
 */
const GroupPricingUpsellMessage = ({
    departmentId,
    quantity,
    sx,
}: {
    departmentId: number;
    quantity: number;
    sx?: SxProps<Theme>;
}) => {
    const upsell = getGroupPricingUpsell(departmentId, quantity);
    if (!upsell) return null;

    const { remaining } = upsell;

    return (
        <Alert severity="info" sx={sx}>
            Buy {remaining} more {remaining === 1 ? "ticket" : "tickets"} to
            unlock group pricing!
        </Alert>
    );
};

export default GroupPricingUpsellMessage;
